import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { FormField, SelectField } from "@/components/common";
import { LOCATION_OPTIONS } from "@/lib/constants";
import { useCompanyStore } from "../hooks";

const CompanySetupStepOne = observer(
  ({
    getFieldError,
    handleBlur,
    companyNameError,
    companyNameDescription,
    companyNameDescriptionClassName,
  }) => {
    const { t } = useTran();
    const { form, setField } = useCompanyStore();

    const handleCompanyNameChange = (event) => {
      setField("companyName", event.target.value);
    };

    const handleCountryChange = (event) => {
      setField("country", event.target.value);
      handleBlur("country")();
    };

    return (
      <div className="space-y-6">
        <div className="space-y-2">
          <FormField
            label={t("What is your company name?")}
            required
            value={form.companyName}
            onChange={handleCompanyNameChange}
            onBlur={handleBlur("companyName")}
            placeholder="Acme Inc."
            error={companyNameError || getFieldError("companyName")}
          />
          {companyNameDescription ? (
            <p
              className={
                companyNameDescriptionClassName ||
                "text-xs text-muted-foreground"
              }
            >
              {companyNameDescription}
            </p>
          ) : null}
        </div>

        <SelectField
          id="country"
          label={t("Where is your company located?")}
          required
          placeholder={t("Select a country")}
          value={form.country}
          options={LOCATION_OPTIONS}
          onChange={handleCountryChange}
          error={getFieldError("country")}
        />
      </div>
    );
  },
);

export default CompanySetupStepOne;
